module.exports = __webpack_public_path__ + "img/partner1.c924feef.png";